
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class ModalLoading extends Vue {
  @Prop(String) loadingMessage!: string;
}
